function randomBase36(length = 6) {
  return Math.random().toString(36).slice(2, 2 + length).toUpperCase().padEnd(length, "X");
}

export function generateClientDealNumber(now = new Date()) {
  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, "0");
  const day = String(now.getUTCDate()).padStart(2, "0");
  const hours = String(now.getUTCHours()).padStart(2, "0");
  const minutes = String(now.getUTCMinutes()).padStart(2, "0");
  const seconds = String(now.getUTCSeconds()).padStart(2, "0");

  return `DL-${year}${month}${day}${hours}${minutes}${seconds}-${randomBase36(6)}`;
}
